exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dN6rNgBM6Hvwi4hCO3PRN {\n  min-height: 185px;\n}\n", ""]);

// exports
exports.locals = {
	"ecgGraph": "dN6rNgBM6Hvwi4hCO3PRN"
};


//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/containers/KardiaRxCCTEcgTable/KardiaRxCCTEcgTable.css
// module id = 9985
// module chunks = 25